import { Route } from '@angular/router';
import { PortalAuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { PortalShellComponent } from './layouts/portal-shell/portal-shell.component';
import { portalAuthCanMatch } from './auth/portal-auth.guard';

export const appRoutes: Route[] = [
  { path: '', pathMatch: 'full', redirectTo: 'login' },

  // Auth pages wrapped in the two-column auth layout
  {
    path: '',
    component: PortalAuthLayoutComponent,
    children: [
      {
        path: 'login',
        loadComponent: () =>
          import('./pages/auth/login/login.component').then((m) => m.PortalLoginComponent),
      },
      {
        path: 'verify',
        loadComponent: () =>
          import('./pages/auth/verify/verify.component').then((m) => m.PortalVerifyComponent),
      },
      {
        path: 'forgot-password',
        loadComponent: () =>
          import('./pages/auth/forgot-password/forgot-password.component').then(
            (m) => m.PortalForgotPasswordComponent,
          ),
      },
    ],
  },

  // Standalone auth pages (no sidebar layout — token arrives from email link)
  {
    path: 'set-password',
    loadComponent: () =>
      import('./pages/auth/set-password/set-password.component').then(
        (m) => m.PortalSetPasswordComponent,
      ),
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('./pages/auth/reset-password/reset-password.component').then(
        (m) => m.PortalResetPasswordComponent,
      ),
  },

  // Protected shell — collapsible sidebar + topbar, requires authenticated customer session
  {
    path: '',
    canMatch: [portalAuthCanMatch],
    component: PortalShellComponent,
    children: [
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./pages/dashboard/dashboard.component').then((m) => m.PortalDashboardComponent),
      },
    ],
  },

  {
    path: 'error/:code',
    loadComponent: () =>
      import('../../../../libs/core/shared/ui/error-reusable/error-reusable').then(
        (m) => m.ErrorReusableComponent,
      ),
  },
  { path: '**', pathMatch: 'full', redirectTo: 'error/404' },
];
